import React from "react";
import { useSelector } from "react-redux";

export const DataPoints = () => {
  const data = useSelector((state) => state.studioInfo.membershipActivityTotals.data);

  return (
    <>
      <div className="section-group padding-right">
        <div>
          <h2 className="title">{data[0].title}</h2>
          <p className="sub-value">
            <a href={data[0].average_eft_value_link} target="_blank" rel="noopener noreferrer">
              {data[0].average_eft_value}
            </a>
          </p>
        </div>
      </div>
      <div className="section-group">
        <div>
          <h2 className="title">{data[1].title}</h2>
          <p className="sub-value">{data[1].forecasted_value}</p>
        </div>
      </div>
    </>
  );
};
